import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import filter from 'lodash/filter';
import map from 'lodash/map';

import {
    SMALL_CITY_FALLBACK,
    LIKED_EVENTS,
    ORGANIZER_ARTICLE_TYPE,
} from '../../../constants/constants';

const _getEventBucketsKeys = (buckets) => {
    let bucketKeys = [];

    /* This was using a constant named EVENT_TYPE = 'any' which failed all the time because that's not a key
     * in our buckets.
     */
    bucketKeys = filter(buckets, ({ type }) => type === 'event');
    bucketKeys = map(bucketKeys, 'key');
    bucketKeys = filter(
        bucketKeys,
        (value) => value !== LIKED_EVENTS || value !== ORGANIZER_ARTICLE_TYPE,
    );

    return bucketKeys;
};

export const isSmallCityFallback = ({ buckets, events }) => {
    let isSmallCity = true;

    if (!isEmpty(buckets)) {
        const keys = _getEventBucketsKeys(buckets);

        isSmallCity = includes(keys, SMALL_CITY_FALLBACK);
    } else if (!isEmpty(events)) {
        const smallCityEventsLength = 8;
        const firstEventBucketLength = events[0]
            ? get(events[0], 'events.length', 0)
            : get(events.results, 'length', 0);

        isSmallCity = firstEventBucketLength < smallCityEventsLength;
    }

    return isSmallCity;
};

export const isZeroContent = ({ buckets, events }) => {
    let response = true;

    if (!isEmpty(buckets)) {
        const keys = _getEventBucketsKeys(buckets);

        response = isEmpty(keys);
    } else if (!isEmpty(events)) {
        const firstEventBucket =
            (events[0] && events[0].events) || (events && events.results);

        response = isEmpty(firstEventBucket);
    }

    return response;
};

export const getFiveToFollowContent = (placeId = '') => {
    const fiveToFollowContent = [];

    // TODO: Properly remove fiveToFollowContent: EB-163777
    // if (placeId) {
    //     fiveToFollowContent = getFiveToFollowData()[placeId];
    // }

    return fiveToFollowContent ? fiveToFollowContent : [];
};
